module.exports = __webpack_public_path__ + "img/icomoon.e8f472e.svg";